<template>
	<div class="home-box" :style="lineProgress">
		<!-- banner -->
		<!-- <div class="banner-box" :style="lineProgress">
			<div class="banner-img" :style="mins">
				<img src="../../assets/image/banner/icon.png" />
			</div>
		</div> -->
		<div class="banner-box" :style="lineProgress">
			<div class="banner_img">
				<div>
					<div class="icon_logo">
						<div>
							<img src="../../assets/image/logo.png" style="width:50px;height: 18px;" />
						</div>
						<div style="color:#fff;">
							<div style="letter-spacing: 9px;margin-top: 4px;">国家信息安全漏洞共享平台</div>
							<div style="margin-top: -6px;">CHINA NATIONAL VULNERABILITY DATABASE</div>
						</div>
					</div>
					<div style="color: #fff;font-size: 34px;font-family: MicrosoftYaHei-Bold;letter-spacing: 10px;font-weight: bold;">工控漏洞子库</div>
				</div>
			</div>
			<!-- <div class="banner-img" :style="mins">
				<div style="display: flex;justify-content: space-between;height: 50px;align-items: center;">
					<img src="../../assets/image/logo.png" style="width:100px;height:auto;" />
					<div style="color: #ffffff;">
						<div style="font-size: 12px;margin: 0;text-align: left;font-family: MicrosoftYaHei-Bold;">国家信息安全漏洞共享平台</div>
						<div style="margin-top: -5px;font-size: 12px;text-align: left;">CHINANATIONALVULNERABILITYDATABASE</div>
					</div>
				</div>
				<div style="color: #fff;font-family: MicrosoftYaHei-Bold;font-weight: bold;">国家工控漏洞库</div>
			</div> -->
		</div>
		<!-- number-list -->
		<div class="number-warning" :style="lineProgress">
			<div class="number-list" :style="min">
				<div @click="jumpListAll()">
					<p class="num" style="color: #000000;">
						{{this.vulnerabilityInfos.total}}
					</p>
					<p class="description">漏洞总数</p>
				</div>
				<div @click="jumpList(1)">
					<p class="num" style="color: #Eb504e;">
						{{this.vulnerabilityInfos.high}}
					</p>
					<p class="description">高危漏洞</p>
				</div>
				<div @click="jumpList(2)">
					<p class="num" style="color: #e8c115;">
						{{this.vulnerabilityInfos.middle}}
					</p>
					<p class="description">中危漏洞</p>
				</div>
				<div @click="jumpList(3)">
					<p class="num" style="color: #399af8;">
						{{this.vulnerabilityInfos.low}}
					</p>
					<p class="description">低危漏洞</p>
				</div>
			</div>
		</div>
		<!-- icon -->
		<div :style="min" class="search-box">
			<div style="width: 49%">
				<router-link to="/bugListphone">
					<img src="../../assets/image/bug_search.png" alt="" style="width: 100%;cursor: pointer;height: auto">
				</router-link>
			</div>
			<div style="width: 49%">
				<img src="../../assets/image/bug_submit.png" alt="" style="width: 100%;cursor: pointer;height: auto" @click="See">
			</div>
		</div>
		<!-- tab-切换页 -->
		<div :style="min" class="tab-box">
			<van-tabs v-model="activeTabs">
				<van-tab title="最新漏洞" style="padding: 15px 12px;background: #fff">
					<div style="border-bottom: 1px solid #f4f4f4;padding-bottom: 10px;margin-bottom: 10px;" v-for="(item,i) in this.newsInfo"
					 :key="i" @click="pushBug(item.id)">
						<p class="listTitle">
							{{item.title}}
						</p>
						<p class="listText" style="text-overflow: -o-ellipsis-lastline;
			                                overflow: hidden;
			                                text-overflow: ellipsis;
			                                display: -webkit-box;
			                                -webkit-line-clamp: 1;
			                                line-clamp: 1;
			                                -webkit-box-orient: vertical;">
							{{item.description}}
						</p>
						<p class="listTime">
							{{item.publicDate.split(' ')[0]}}
						</p>
					</div>
					<p class="moreBtn">
						<router-link to="/bugListphone">查看更多</router-link>
					</p>
				</van-tab>
<!--				<van-tab title="热点事件" style="padding: 15px 12px;background: #fff">-->
<!--					<div style="border-bottom: 1px solid #f4f4f4;padding-bottom: 10px;margin-bottom: 10px;" v-for="(item,i) in this.hotCon"-->
<!--					 :key="i" @click="pushHot(item.id)">-->
<!--						<p class="listTitle">-->
<!--							{{item.title}}-->
<!--						</p>-->
<!--						<p class="listText" style="text-overflow: -o-ellipsis-lastline;-->
<!--			                                overflow: hidden;-->
<!--			                                text-overflow: ellipsis;-->
<!--			                                display: -webkit-box;-->
<!--			                                -webkit-line-clamp: 1;-->
<!--			                                line-clamp: 1;-->
<!--			                                -webkit-box-orient: vertical;">-->
<!--							{{item.summary}}-->
<!--						</p>-->
<!--						<p class="listTime">-->
<!--							{{item.publishTime.split(' ')[0]}}-->
<!--						</p>-->
<!--					</div>-->
<!--					<p class="moreBtn">-->
<!--						<router-link to="/focus">查看更多</router-link>-->
<!--					</p>-->
<!--				</van-tab>-->
<!--				<van-tab title="最新公告" style="padding: 15px 12px;background: #fff">-->
<!--					<div style="border-bottom: 1px solid #f4f4f4;padding-bottom: 10px;margin-bottom: 10px;" v-for="(item,i) in this.anquan"-->
<!--					 :key="i" @click="pushNotice(item.id)">-->
<!--						<p class="listTitle">-->
<!--							{{item.title}}-->
<!--						</p>-->
<!--						<p class="listText" style="text-overflow: -o-ellipsis-lastline;-->
<!--			                                overflow: hidden;-->
<!--			                                text-overflow: ellipsis;-->
<!--			                                display: -webkit-box;-->
<!--			                                -webkit-line-clamp: 1;-->
<!--			                                line-clamp: 1;-->
<!--			                                -webkit-box-orient: vertical;">-->
<!--							{{item.summary}}-->
<!--						</p>-->
<!--						<p class="listTime">-->
<!--							{{item.publishTime.split(' ')[0]}}-->
<!--						</p>-->
<!--					</div>-->
<!--					<p class="moreBtn">-->
<!--						<router-link to="/noticePhone">查看更多</router-link>-->
<!--					</p>-->
<!--				</van-tab>-->
			</van-tabs>
		</div>
		<!-- footer -->
		<div class="footerPages" :style="lineProgress">
			<Foot></Foot>
		</div>
	</div>
</template>

<script>
	import Foot from '../../components/phoneHeader/footerPhone'
	import {
		getCountNumber,
		getNew,
		getHotBug,
		getBugLine,
		getBugPie,
		getBugPieTwo,
		getHotMsg
	} from '../../api/index'
	export default {
		name: "homePage",
		components: {
			Foot
		},
		computed: {
			lineProgress() {
				const style = {}
				style.width = this.screenWidth + 'px';
				return style
			},
			min() {
				const style = {}
				style.width = this.screenWidth * 0.95 + 'px';
				return style
			},
			mins() {
				const style = {}
				style.width = this.screenWidth * 0.6 + 'px';
				return style
			}
		},
		data() {
			return {
				activeTabs: 0,
				// 判断查看更多
				tabKey: 1,
				// 漏洞数量
				vulnerabilityInfos: {},
				// 最新漏洞
				newsInfo: [],
				// 热门漏洞
				hotInfo: [],
				// 热点推荐
				hotCon: [],
				// 安全公告
				anquan: [],
			}
		},
		methods: {
			/**=============跳转到漏洞列表页面的方法================== */
			//漏洞总数跳转
			jumpListAll() {
				this.$router.push({
					name: 'bugListphone'
				})
			},
			jumpList(val) {
				if (val === 1) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 3
						}
					})
				} else if (val === 2) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 2
						}
					})
				} else if (val === 3) {
					this.$router.push({
						name: 'bugListphone',
						params: {
							i: val,
							value: 1
						}
					})
				}

			},
			See(e) {
				window.location.href = 'https://www.cnvd.org.cn/user/login'
			},
			callback(key) {
				this.tabKey = key
			},
			// 日期转换
			getdate() {
				var now = new Date(),
					y = now.getFullYear(),
					m = now.getMonth() + 1,
					d = now.getDate();
				return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
			},
			// 获取漏洞数量
			getCount() {
				getCountNumber().then(res => {
					if (res.status == 200) {
						this.vulnerabilityInfos = res.data
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 获取热点推荐
			getHotCon() {
				var params = {
					type: 0
				}
				getHotMsg(params).then(res => {
					if (res.status == 200) {
						var data = res.data.page.records
						for (var i = 0; i < data.length; i++) {
							data[i].publishTime = this.dateUtil.dateFormat(data[i].publishTime)
						}
						this.hotCon = data
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 获取安全公告
			getMsg() {
				var params = {
					type: 2
				}
				getHotMsg(params).then(res => {
					if (res.status == 200) {
						var data = res.data.page.records
						for (var i = 0; i < data.length; i++) {
							data[i].publishTime = this.dateUtil.dateFormat(data[i].publishTime)
						}
						this.anquan = data
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 获取最新漏洞
			getNews() {
				getNew().then(res => {
					if (res.status == 200) {
						this.newsInfo = res.data.page.records
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 获取热门漏洞
			getHot() {
				getHotBug().then(res => {
					if (res.status == 200) {
						this.hotInfo = res.data
					} else if (res.status == 504) {
						this.$toast(res.msg);
					} else {
						this.$toast(res.msg);
					}
				})
			},
			// 跳转热点推荐
			pushHot(id) {
				this.$router.push({
					name: 'focusInfo',
					params: {
						key: id
					}
				})
			},
			// 跳转最新漏洞
			pushBug(id) {
				this.$router.push({
					name: 'bugInfoPhone',
					params: {
						key: id
					}
				})
			},
			// 跳转最新公告
			pushNotice(id) {
				this.$router.push({
					name: 'noticeInfoPhone',
					params: {
						key: id
					}
				})
			}
		},
		created() {
			this.getCount();
			this.getHotCon();
			this.getNews();
			this.getMsg();

		}
	}
</script>

<style scoped>
	p {
		margin: 0;
	}

	.home-box {
		height: calc(100% - 44px);
		overflow-y: auto;
	}

	.banner-box {
		background: url("../../assets/image/banner/index.png") center center no-repeat;
		background-size: cover;
		height: 180px;
	}
	.banner_img{
		width: 85%;
		height: 100%;
		margin: 0 auto;
		display: flex;
		align-items: center;
	}
	.icon_logo{
		display: flex;
		align-items: center;
	}

	.number-warning {
		height: 74px;
	}

	.number-list {
		background-color: #ffffff;
		margin: 0 auto;
		height: 80px;
		border-radius: 4px;
		position: relative;
		top: -25px;
		display: flex;
		justify-content: space-around;
		-webkit-box-shadow: 0 5px 20px 0 rgba(6, 3, 3, .03);
		box-shadow: 0 5px 20px 0 rgba(6, 3, 3, .03);
	}

	.num {
		font-size: 28px;
		font-weight: 700;
		color: #252525;
		height: 50px;
		line-height: 50px;
		text-align: center;
	}

	.description {
		font-size: 14px;
		font-weight: 700;
		color: #333;
		text-align: center;
	}

	.search-box {
		margin: 0 auto;
		display: flex;
		justify-content: space-between;
	}

	.tab-box {
		margin: 0 auto;
		margin-top: 10px;
	}

	/deep/ .van-tab--active {
		color: #2874be !important;
		font-weight: 700;
	}

	/deep/ .van-tabs__line {
		position: absolute;
		bottom: 15px;
		left: 0;
		z-index: 1;
		width: 15px !important;
		height: 3px;
		border-radius: 5px;
		display: inline-block;
		margin-top: 8px;
		background-color: #2978c3;
	}

	.moreBtn {
		font-size: 12px;
		line-height: 16px;
		font-weight: 400;
		color: #2978c3;
		display: inline-block;
	}

	.moreBtn a {
		font-size: 12px;
		color: #2978c3;
	}

	.listTitle {
		font-size: 14px;
		color: #333;
		font-weight: 700;
		line-height: 24px;
		margin-bottom: 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		text-align: left;
	}

	.listText {
		font-size: 12px;
		color: #999;
		font-weight: 400;
		line-height: 16px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-align: left;
	}

	.listTime {
		font-size: 12px;
		font-weight: 400;
		color: #666;
		line-height: 16px;
		text-align: right;
		margin-top: 10px;
	}

	.footerPages {
		/* position: fixed; */
		position: -webkit-sticky;
		position: sticky;
		bottom: -120px;
	}
</style>
